





























































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
import gtSearch from "@/components/pages/Product/search.vue";
import selectFamilyDialog from "@/components/pages/ProductCreate/selectFamily.vue";
import exportProducts from "@/components/pages/Product/exportProducts.vue";

// import GtTableJson from "./views/button.vue";
import GtTableJson from "./components/el-table-json/index.js";

const product = namespace("product");
const Root = namespace("root");
const defaultImageLink = require("@/assets/image/default_product_image_v2.png");
@Component({
  components: { gtSearch, selectFamilyDialog, exportProducts, GtTableJson },
  filters: {
    pic0(value: string) {
      if (value) {
        return value.split(",")[0] || "@/assets/image/default.png";
      }
    }
  }
})
export default class HelloWorld extends Vue {
  @product.Getter productList: any;
  @product.Getter total: number;
  @product.State PageInput: any;
  @product.State loading: boolean;
  @product.State params: any;
  @product.Action getPorducts: any;
  @product.Action deleteProduct: any;
  @product.Action UpdateProductStatus: any;
  @product.Action updateProductStatusBatch: any;
  @product.Mutation setPageInput: any;
  @Root.State permission;

  private columns = Object.freeze([
    {
      // 可以指定列的宽度，与element-ui原生用法一致
      width: 220,
      label: "商品名称",
      prop: "productName"
    },
    {
      label: "商品自定义编码",
      prop: "productCode",
      showOverflowTooltip: false,
      links: {
        underline: false,
        type: "primary",
        click: (...args) => {
          this._handleEdit(args);
        }
      }
      // 格式化表格,与element-ui 的表格属性相同
      // formatter(row, column, cellValue) {
      //   return cellValue === 1 ? "男" : "女";
      // }
    },
    {
      rowId: "2",
      label: "商品编码",
      prop: "productCode",
      showOverflowTooltip: true,
      useSlot: true
      // 格式化表格,与element-ui 的表格属性相同
      // formatter(row, column, cellValue) {
      //   return cellValue === 1 ? "男" : "女";
      // }
    },
    // {
    //   label: "年龄",
    //   prop: "age"
    // },
    // {
    //   label: "公众号",
    //   prop: "officialAccount"
    // },
    // 行编辑按钮，在表格末尾出现，自动锁定右侧
    {
      width: 180,
      label: "操作",
      actions: [
        // 可以是单个object
        {
          id: "edit",
          text: "编辑",
          link: "1111",
          underline: false,
          type: "primary",
          // 可以通过before控制按钮是否显示，比如下面年龄四十岁的才会显示编辑按钮
          before(row) {
            return row.status < 2;
          },
          click: row => {
            // this._handleEdit(row);
            console.log(row, "args - actions");
          }
        },
        {
          id: "delete",
          text: "删除",
          icon: "el-icon-delete",
          children: [
            {
              label: "child测试"
            }
          ],
          disabled(row) {
            return row.status === 0;
          },
          // 为了拿到this,这里需要用箭头函数
          click: row => {
            this.$alert(`row数据${row.productName}`);
          }
        }
      ]
    }
  ]);

  private currentPage = 1;
  // 每页条数
  private pageSize = 10;
  // 总条数

  // 是否显示多选框
  private selectable = true;
  // 是否显示序号列
  private sequence = true;

  get readonly() {
    return {
      create: !this.permission.PIM_PRODUCT_CREATE_BUTTON,
      edit: !this.permission.PIM_PRODUCT_EDIT_BUTTON,
      delete: !this.permission.PIM_PRODUCT_DELETE_BUTTON,
      onBatch: !this.permission.PIM_PRODUCT_ON_BATCH_BUTTON,
      downBatch: !this.permission.PIM_PRODUCT_DOWN_BATCH_BUTTON,
      down: !this.permission.PIM_PRODUCT_DOWN_BUTTON,
      on: !this.permission.PIM_PRODUCT_ON_BUTTON
    };
  }

  get isHidden() {
    return false;
  }

  getRowKeys(row) {
    return row.productCode;
  }
  get operateList() {
    return [
      {
        name: "deactivate",
        command: "handleChangeStatus",
        text: this.$t("Product.deactivate"),
        disabled: this.readonly.down
      },
      {
        name: "activate",
        command: "handleChangeStatus",
        text: this.$t("Product.activate"),
        disabled: this.readonly.on
      },
      {
        name: "delete",
        command: "handleDelete",
        text: this.$t("Basic.Delete"),
        disabled: this.readonly.delete
      }
    ];
  }
  handleOperateClick(command, row) {
    this[command] && this[command](row);
  }
  operateIsShow(node, li) {
    if (li.name === "activate") {
      return node.status !== 1;
    } else if (li.name === "deactivate") {
      return node.status === 1;
    } else {
      return true;
    }
  }
  async mounted() {
    this.params.productName = "";
    this.setPageInput({
      ...this.PageInput,
      pageNum: 1
    });
    await this.getPorducts();
  }

  handleDelete(data): void {
    if (this.readonly.delete) {
      return;
    }
    let { productCode, orgCode } = data;
    const message: any = this.$t("Basic.confirm_delete");
    this["$confirm"](message, "").then(async () => {
      await this.deleteProduct({
        codeList: [productCode],
        orgCode
      });
      this.handleDeleteLastone();
    });
  }

  /**
   * @desc 处理图片展示
   * @return { string }
   */
  handleMobileMediaLink(listData) {
    const { mobileMediaLink, mediaLink } = listData;
    return mobileMediaLink
      ? mobileMediaLink.split(",")[0]
      : mediaLink
      ? mediaLink.split(",")[0]
      : defaultImageLink;
  }

  async handleDeleteLastone() {
    if (this.productList.length == 1) {
      this.setPageInput({
        ...this.PageInput,
        pageNum: this.PageInput.pageNum - 1
      });
    }
    await this.getPorducts();
    this.clearSelection();
  }

  async handleChangeStatus(row): Promise<void> {
    let { productCode, status } = row;
    await this.UpdateProductStatus({
      productCode: productCode,
      status: Number(!status)
    });
    let info: any = this.$t("Basic.success");
    this.$message({
      type: "success",
      message: info
    });
    await this.getPorducts();
    this.clearSelection();
  }

  async commonPageChange(val = {}) {
    this.setPageInput({
      ...this.PageInput,
      ...val
    });
    await this.getPorducts();
  }

  async handlePageChange(val) {
    this.commonPageChange({ pageNum: val });
  }

  async handleSizeChange(val) {
    this.commonPageChange({ pageSize: val });
  }
  searchProduct(data) {
    // console.log(data);
  }
  // 导出筛选商品
  exportProduct() {
    (this as any).$refs.exportProducts.visible = true;
  }
  createProduct() {
    if (this.readonly.create) {
      return;
    }
    (this.$refs.selectFamilyDialog as any).visible = true;
  }
  batchProducts = [];
  handleSelectionProduct(list) {
    this.batchProducts = list;
  }
  toggleStatusBatch(oldStatus, status, batchNotice, noreat) {
    let batchEmpty: any = this.$t("Product.batch_empty");
    let confirm: any = this.$t("Basic.Confirm");
    let cancel: any = this.$t("Basic.Cancel");
    if (!this.batchProducts.length) {
      this.$message({
        message: batchEmpty,
        type: "warning"
      });
      return;
    }
    let length = this.batchProducts.filter(_ => _.status === oldStatus).length;
    if (length === 0) {
      this.$message({
        message: noreat,
        type: "error"
      });
      return;
    }
    this.$confirm(batchNotice, {
      confirmButtonText: confirm,
      cancelButtonText: cancel,
      type: "warning"
    })
      .then(async () => {
        let params = this.batchProducts.map(_ => {
          return { productCode: _.productCode, status: status };
        });
        await this.updateProductStatusBatch(params);
        let info: any = this.$t("Basic.success");
        this.$message({
          type: "success",
          message: info
        });
        await this.getPorducts();
        if (this.productList.length === 0) {
          await this.handlePageChange(1);
        }
        this.clearSelection();
      })
      .catch(error => {
        console.log(error);
      });
  }
  // 批量上架
  handleBatchActive() {
    if (this.readonly.onBatch) {
      return;
    }
    let num = this.batchProducts.length;
    let batchNotice: any =
      (this as any).$t("Product.batch_num", { num }) +
      this.$t("Product.batch_active_notice");
    let noRepeat: any = this.$t("Product.no_active");
    this.toggleStatusBatch(0, 1, batchNotice, noRepeat);
  }
  // 批量下架
  handleBatchDeactive() {
    if (this.readonly.downBatch) {
      return;
    }
    let num = this.batchProducts.length;
    let batchNotice: any =
      (this as any).$t("Product.batch_num", { num }) +
      this.$t("Product.batch_deactive_notice");
    let noRepeat: any = this.$t("Product.no_deactive");
    this.toggleStatusBatch(1, 0, batchNotice, noRepeat);
  }
  clearSelection() {
    (this.$refs.productTable as any).clearSelection();
    this.batchProducts = [];
  }
  handleEdit(row) {
    if (this.readonly.edit) {
      return;
    }
    let routeUrl = this.$router.resolve({
      name: "ProductEdit",
      query: { productCode: row.productCode }
    });
    window.open(routeUrl.href, "_blank");
  }
  handleView(row) {
    let routeUrl = this.$router.resolve({
      name: "ProductEdit",
      query: { productCode: row.productCode, isViewMode: "true" }
    });
    window.open(routeUrl.href, "_blank");
  }

  getFirstProp(list, prop) {
    return (list && list[0] && list[0][prop]) || 0.0;
  }
  _handlePageChange() {
    this.getPorducts();
  }
  _handleEdit(row) {
    this.$msgbox({
      title: "编辑"
    });
    console.log(row, "edit");
  }
}
